import { useEffect, useState } from "react";
import getUrl from "../../tools/get-domain";

const levels = ["همه", "مقدماتی", "متوسط", "پیشرفته"];

const specializedServices = [
    {
        title: "نبض بازار اختیار معامله",
        icon: "https://sas.amin.parminstorage.ir/hirad/static/icon/home/samane-hoshmand-icon.svg",
        messages: [
            "شناسایی بهترین استراتژی بر اساس روند نماد",
            "شناسایی بهترین قرارداد بر اساس هر استراتژی",
            "مشاهده نقشه روزانه و هفتگی بازار",
        ],
        href: "https://options.binazirchart.ir/",
    },
    {
        title: "دیده‌بان پیشرفته اختیار معامله",
        icon: "https://sas.amin.parminstorage.ir/hirad/static/icon/home/nabz-bazar-icon.svg",
        messages: [
            "دسترسی سریع به آخرین دیتا",
            "دقیق‌ترین دیده‌بان اختیار معامله",
            "ماشین حساب بلک شولز",
        ],
        href: "https://binazirchart.ir/vip/options",
    },
    {
        title: "فیلترهای تخصصی اختیار معامله",
        icon: "https://sas.amin.parminstorage.ir/hirad/static/icon/home/exir-filter-icon.svg",
        messages: [
            "رصد لحظه‌ای و تاریخی حقوقی به‌عنوان رایتر",
            "بررسی دیدگاه حقوقی‌ها در هر نماد",
            "امکان اعمال بیش از صد فیلتر مختلف",
        ],
        href: "https://binazirchart.ir/vip/option_filter",
    },
];

const levelMap = {
    همه: "all",
    مقدماتی: "beginner",
    متوسط: "regular",
    پیشرفته: "pro",
};
const levelInfo = (level) =>
    level === "beginner"
        ? [
            "مقدماتی",
            "عادی",
            "tw-bg-emerald-50 tw-text-emerald-700 tw-ring-emerald-200",
        ]
        : level === "pro"
            ? [
                "پیشرفته",
                "ویژه",
                "tw-bg-amber-50 tw-text-amber-700 tw-ring-amber-200",
            ]
            : ["متوسط", "عادی", "tw-bg-sky-50 tw-text-sky-700 tw-ring-sky-200"];

const SearchIcon = () => (
    <svg className="tw-size-5" viewBox="0 0 24 24" fill="none">
        <path
            d="m21 21-4.4-4.4m2.4-5.6a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
        />
    </svg>
);
const EyeIcon = () => (
    <svg className="tw-size-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="2.75" stroke="currentColor" strokeWidth="1.7" />
    </svg>
);

const CheckIcon = () => (
    <svg
        className="tw-size-5 tw-shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
    >
        <circle cx="10" cy="10" r="10" fill="#3B6CE9" />
        <path
            d="m5.5 10.2 2.8 2.4 6.2-6"
            stroke="white"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const ServiceCard = ({ service }) => (
    <article className="tw-flex tw-h-full tw-flex-col tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-shadow-sm tw-transition tw-duration-200 hover:-tw-translate-y-1 hover:tw-border-sky-200 hover:tw-shadow-lg md:tw-p-6">
        <h3 className="tw-m-0 tw-min-h-[56px] tw-text-center tw-text-lg tw-font-black tw-leading-7 tw-text-slate-900">
            {service.title}
        </h3>
        <a
            href={service.href}
            className="tw-mt-5 tw-flex tw-size-24 tw-items-center tw-justify-center tw-rounded-full tw-bg-slate-100 tw-p-4 tw-transition group-hover:tw-bg-sky-50"
        >
            <img
                src={service.icon}
                alt={service.title}
                className="tw-size-16 tw-object-contain"
                loading="lazy"
            />
        </a>
        <ul className="tw-my-6 tw-w-full tw-flex-1 tw-space-y-4 tw-p-0">
            {service.messages.map((message) => (
                <li
                    key={message}
                    className="tw-flex tw-items-start tw-gap-2 tw-text-base tw-font-medium tw-leading-7 tw-text-slate-700"
                >
                    <CheckIcon />
                    <span>{message}</span>
                </li>
            ))}
        </ul>
        <a
            href={service.href}
            className="tw-inline-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-text-center tw-text-base tw-font-extrabold tw-text-white tw-transition hover:tw-bg-blue-700 hover:tw-text-white"
        >
            برو به {service.title}
        </a>
    </article>
);

const ClipboardIcon = () => (
    <svg
        className="tw-size-4 tw-shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
    >
        <rect
            x="8"
            y="8"
            width="12"
            height="12"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.8"
        />
        <path
            d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
        />
    </svg>
);

const getPlainCode = (html = "") => {
    const element = document.createElement("textarea");
    element.innerHTML = html.replace(/<[^>]*>/g, "").trim();

    return element.value;
};
const filterColumnStyles = {
    title: {
        minWidth: "118px",
        flex: "1 1 auto",
    },
    code: {
        width: "clamp(38px, 10vw, 78px)",
        flex: "0 0 clamp(38px, 10vw, 78px)",
    },
    level: {
        width: "clamp(58px, 13vw, 105px)",
        flex: "0 0 clamp(58px, 13vw, 105px)",
    },
    access: {
        width: "clamp(52px, 12vw, 95px)",
        flex: "0 0 clamp(52px, 12vw, 95px)",
    },
    details: {
        width: "clamp(38px, 10vw, 82px)",
        flex: "0 0 clamp(38px, 10vw, 82px)",
    },
};
const filterTableRowStyle = {
    direction: "rtl",
    gap: "clamp(2px, 0.6vw, 12px)",
};

const filterActionButtonStyle = {
    paddingInline: "8px",
};
const Row = ({ item, onCopied, showButtonText }) => {
    const [label, access, badgeClass] = levelInfo(item.level);
    const [copied, setCopied] = useState(false);
    const hasCode = Boolean(item.code);

    const copyCode = async () => {
        if (!hasCode) return;
        try {
            await navigator.clipboard.writeText(getPlainCode(item.code));
            setCopied(true);
            onCopied();
            window.setTimeout(() => setCopied(false), 1800);
        } catch (_) {
            setCopied(false);
        }
    };

    return (
        <div className="tw-flex tw-w-full tw-items-center tw-border-b tw-border-slate-200 tw-bg-white tw-px-1.5 tw-py-2.5 tw-text-slate-800 tw-transition hover:tw-bg-sky-50/70 md:tw-px-5 md:tw-py-4" style={filterTableRowStyle}>
            <div className="tw-shrink-0 tw-text-right" style={filterColumnStyles.title}>
                <span
                    title={item.title}
                    className="tw-block tw-min-w-0 tw-truncate tw-text-sm tw-font-extrabold md:tw-text-lg"
                >
                    {item.title}
                </span>
            </div>
            <div className="tw-shrink-0 tw-text-center" style={filterColumnStyles.code}>
                <button
                    type="button"
                    onClick={copyCode}
                    disabled={!hasCode}
                    title={hasCode ? "کپی کد فیلتر" : "کدی ثبت نشده است"}
                    className={`tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-p-0 tw-text-sm tw-font-extrabold tw-transition md:tw-h-10 md:tw-w-auto ${hasCode ? "tw-border-sky-500 tw-bg-sky-50 tw-text-sky-700 hover:tw-bg-sky-600 hover:tw-text-white" : "tw-cursor-not-allowed tw-border-slate-200 tw-bg-slate-100 tw-text-slate-400"}`}
                    style={showButtonText ? filterActionButtonStyle : undefined}
                >
                    <ClipboardIcon />
                    {showButtonText && (
                        <span style={{ whiteSpace: "nowrap" }}>
                            {copied ? "کپی شد" : hasCode ? "کپی کد" : "بدون کد"}
                        </span>
                    )}
                </button>
            </div>
            <div className="tw-shrink-0 tw-text-center" style={filterColumnStyles.level}>
                <span
                    className={`tw-inline-flex tw-max-w-full tw-justify-center tw-rounded-full tw-px-1 tw-py-1 tw-text-[10px] tw-font-bold md:tw-w-fit md:tw-px-3 md:tw-text-sm tw-ring-1 tw-ring-inset ${badgeClass}`}
                >
                    {label}
                </span>
            </div>
            <div className="tw-shrink-0 tw-text-center" style={filterColumnStyles.access}>
                <span className="tw-inline-flex tw-max-w-full tw-justify-center tw-rounded-full tw-bg-slate-100 tw-px-1 tw-py-1 tw-text-[10px] tw-font-bold md:tw-w-fit md:tw-px-3 md:tw-text-sm tw-text-slate-600">
                    {access}
                </span>
            </div>
            <div className="tw-shrink-0 tw-text-center" style={filterColumnStyles.details}>
                <a
                    href={`/بورس/product/${item.id}/${item.slug}`}
                    className="tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-sky-500 tw-bg-white tw-p-0 tw-text-sm tw-font-extrabold tw-text-sky-700 tw-shadow-sm tw-transition hover:tw-bg-sky-600 hover:tw-text-white hover:tw-shadow-md md:tw-h-10 md:tw-w-auto"
                    style={showButtonText ? filterActionButtonStyle : undefined}
                >
                    <EyeIcon />
                    {showButtonText && <span>جزئیات</span>}
                </a>
            </div>
        </div>
    );
};

export default function FiltersPage() {
    const [selected, setSelected] = useState("همه");
    const [data, setData] = useState([]);
    const [query, setQuery] = useState("");
    const [state, setState] = useState("loading");
    const [copyNotice, setCopyNotice] = useState(false);
    const [showButtonText, setShowButtonText] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth >= 768 : true,
    );
    const url = `${getUrl().REACT_APP_FILTERS}`;

    const showCopyNotice = () => {
        setCopyNotice(true);
        window.setTimeout(() => setCopyNotice(false), 3000);
    };

    useEffect(() => {
        const handleResize = () => setShowButtonText(window.innerWidth >= 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        fetch(url, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) throw Error();
                return response.json();
            })
            .then((result) => {
                setData(result.data);
                setState("ready");
            })
            .catch((error) => {
                if (error.name !== "AbortError") setState("error");
            });
        return () => controller.abort();
    }, [url]);

    const search = query.trim().toLocaleLowerCase("fa");
    const filtered = data.filter(
        (item) =>
            (!search || item.title.toLocaleLowerCase("fa").includes(search)) &&
            (levelMap[selected] === "all" || item.level === levelMap[selected]),
    );

    return (
        <section className="tw-w-full tw-px-1 tw-py-4 md:tw-px-6 md:tw-py-10 xl:tw-px-12">
            {copyNotice && (
                <div
                    role="status"
                    className="tw-fixed tw-right-3 tw-top-3 tw-z-[9999] tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-emerald-200 tw-bg-white tw-px-4 tw-py-3 tw-text-sm tw-font-extrabold tw-text-emerald-700 tw-shadow-lg"
                >
                    <CheckIcon />
                    <span>کد فیلتر موردنظر در کلیپ‌بورد ذخیره شد.</span>
                </div>
            )}
            <div className="tw-mx-auto tw-mb-8 tw-max-w-7xl tw-space-y-8">
                <section className="tw-mx-auto tw-w-full lg:tw-w-1/2">
                    <div className="tw-overflow-hidden tw-rounded-xl tw-border tw-border-sky-100 tw-bg-white tw-shadow-sm">
                        <div className="tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-sky-100 tw-bg-sky-50/60 tw-p-4">
                            <span className="tw-flex tw-size-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-sky-600 tw-text-white">
                                <svg
                                    className="tw-size-5"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    aria-hidden="true"
                                >
                                    <rect
                                        x="3"
                                        y="5"
                                        width="18"
                                        height="14"
                                        rx="3"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                    />
                                    <path d="m10 9 5 3-5 3V9Z" fill="currentColor" />
                                </svg>
                            </span>
                            <div>
                                <h2 className="tw-m-0 tw-text-lg tw-font-black tw-text-slate-900 md:tw-text-xl">
                                    نحوه اجرای فیلترها در سایت بورس
                                </h2>
                                <p className="tw-m-0 tw-mt-1 tw-text-sm tw-text-slate-500">
                                    پیش از استفاده، راهنمای کوتاه زیر را مشاهده کنید.
                                </p>
                            </div>
                        </div>
                        <div className="tw-p-3">
                            <div className="tw-aspect-video tw-overflow-hidden tw-rounded-lg tw-bg-slate-950">
                                <iframe
                                    title="نحوه اجرای فیلترها در سایت بورس"
                                    src="https://www.aparat.com/video/video/embed/videohash/s507039/vt/frame"
                                    allowFullScreen
                                    className="tw-h-full tw-w-full tw-border-0"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                {/* ابزارهای تخصصی بازار اختیار معامله - برای فعال‌سازی، این کامنت JSX را بردارید.
        <section>
          <div className="tw-mb-5 tw-flex tw-items-center tw-gap-3">
            <span className="tw-flex tw-size-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-violet-50 tw-text-violet-600">
              <svg className="tw-size-6" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 18V9m8 9V5m8 13v-7M2 18h20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="m4 8 7-4 8 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </span>
            <div><h2 className="tw-m-0 tw-text-xl tw-font-black tw-text-slate-900 md:tw-text-2xl">ابزارهای تخصصی بازار اختیار معامله</h2><p className="tw-m-0 tw-mt-1 tw-text-sm tw-font-medium tw-text-slate-500 md:tw-text-base">دسترسی سریع به ابزارهای تحلیلی و فیلترهای حرفه‌ای بازار</p></div>
          </div>
          <div className="tw-grid tw-gap-4 md:tw-grid-cols-3">{specializedServices.map(service => <ServiceCard key={service.title} service={service}/>)}</div>
        </section>
        */}
            </div>
            <div className="tw-mx-auto tw-max-w-7xl tw-overflow-hidden tw-rounded-xl tw-border tw-border-sky-100 tw-bg-white tw-shadow-sm">
                <header className="tw-border-b tw-border-sky-100 tw-bg-sky-50/60 tw-p-4 md:tw-p-6">
                    <div className="tw-mb-5 tw-flex tw-items-center tw-gap-3">
                        <span className="tw-flex tw-size-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-sky-600 tw-text-white tw-shadow-sm">
                            <SearchIcon />
                        </span>
                        <div>
                            <h1 className="tw-m-0 tw-text-xl tw-font-black tw-text-slate-900 md:tw-text-2xl">
                                جستجوی فیلترهای بورسی
                            </h1>
                            <p className="tw-m-0 tw-mt-1 tw-text-sm tw-font-medium tw-text-slate-500 md:tw-text-base">
                                نام فیلتر را جستجو کنید یا سطح موردنظر را انتخاب کنید.
                            </p>
                        </div>
                    </div>
                    <div className="tw-grid tw-gap-3 lg:tw-grid-cols-[minmax(0,1fr)_auto] lg:tw-items-center">
                        <label className="tw-relative tw-w-full lg:tw-w-96">
                            <span className="tw-absolute tw-inset-y-0 tw-right-4 tw-flex tw-items-center tw-text-slate-400">
                                <SearchIcon />
                            </span>
                            <input
                                type="search"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                placeholder="نام فیلتر را وارد کنید..."
                                className="tw-h-12 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-pr-12 tw-pl-4 tw-text-base tw-font-medium tw-text-slate-800 tw-outline-none tw-transition placeholder:tw-text-slate-400 focus:tw-border-sky-400 focus:tw-ring-4 focus:tw-ring-sky-100"
                            />
                        </label>
                        <div className="tw-flex tw-flex-wrap tw-gap-2 lg:tw-justify-self-end">
                            {levels.map((level) => (
                                <button
                                    key={level}
                                    type="button"
                                    onClick={() => setSelected(level)}
                                    className={`tw-h-11 tw-rounded-lg tw-px-4 tw-text-sm tw-font-extrabold tw-transition md:tw-text-base ${selected === level ? "tw-bg-sky-600 tw-text-white tw-shadow-sm tw-ring-2 tw-ring-sky-200" : "tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 hover:tw-border-sky-300 hover:tw-bg-sky-50 hover:tw-text-sky-700"}`}
                                >
                                    {level}
                                </button>
                            ))}
                        </div>
                    </div>
                </header>
                <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-slate-100 tw-px-4 tw-py-3 md:tw-px-6">
                    <span className="tw-text-sm tw-font-bold tw-text-slate-500">
                        نتایج جستجو
                    </span>
                    <span className="tw-rounded-full tw-bg-sky-50 tw-px-3 tw-py-1 tw-text-sm tw-font-black tw-text-sky-700">
                        {filtered.length} فیلتر
                    </span>
                </div>
                {state === "loading" ? (
                    <div className="tw-space-y-3 tw-p-5">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div
                                key={i}
                                className="tw-h-16 tw-animate-pulse tw-rounded-lg tw-bg-slate-100"
                            />
                        ))}
                    </div>
                ) : state === "error" ? (
                    <div className="tw-m-5 tw-rounded-lg tw-border tw-border-red-200 tw-bg-red-50 tw-p-5 tw-text-center tw-font-bold tw-text-red-700">
                        دریافت فیلترها با خطا مواجه شد.
                    </div>
                ) : filtered.length === 0 ? (
                    <div className="tw-px-5 tw-py-16 tw-text-center">
                        <p className="tw-m-0 tw-text-lg tw-font-black tw-text-slate-700">
                            فیلتر موردنظر پیدا نشد
                        </p>
                        <p className="tw-m-0 tw-mt-2 tw-text-sm tw-text-slate-500">
                            عبارت جستجو یا سطح انتخاب‌شده را تغییر دهید.
                        </p>
                    </div>
                ) : (
                    <div>
                        <div className="tw-flex tw-w-full tw-items-center tw-bg-slate-50 tw-px-1.5 tw-py-3 tw-text-[10px] tw-font-black tw-text-slate-500 md:tw-px-5 md:tw-text-sm" style={filterTableRowStyle}>
                            <span className="tw-shrink-0 tw-truncate tw-text-right" style={filterColumnStyles.title}>
                                عنوان فیلتر
                            </span>
                            <span className="tw-shrink-0 tw-text-center" style={filterColumnStyles.code}>
                                کد
                            </span>
                            <span className="tw-shrink-0 tw-text-center" style={filterColumnStyles.level}>
                                سطح
                            </span>
                            <span className="tw-shrink-0 tw-text-center" style={filterColumnStyles.access}>
                                دسترسی
                            </span>
                            <span className="tw-shrink-0 tw-text-center" style={filterColumnStyles.details}>
                                جزئیات
                            </span>
                        </div>
                        {filtered.map((item) => (
                            <Row
                                key={item.id}
                                item={item}
                                onCopied={showCopyNotice}
                                showButtonText={showButtonText}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
